import Dashboard from "../pages/Dashboard";
import Staff from "../pages/Staff";
import State from "../pages/State";
import City from "../pages/City";
import Permission from "../pages/Permission";
import Page404 from "../pages/404";
import ComingSoon from "../pages/ComingSoon";
import EditProfile from "../pages/EditProfile";
import Menu from "../pages/Menu";
import Notification from "../pages/Notification";
import Role from "../pages/Role";
import Offline from "pages/Offline";
import ChatHistory from "pages/ChatHistory";
import EmployeeChats from "pages/EmployeeChats";

/*
//  * ⚠ These are internal routes!
//  * They will be rendered inside the app, using the default `containers/Layout`.
//  * If you want to add a route to, let's say, a landing page, you should add
//  * it to the `App`'s router, exactly like `Login`, `CreateAccount` and other pages
//  * are routed.
//  *
//  * If you're looking for the links rendered in the SidebarContent, go to
//  * `routes/sidebar.js`
 */

const routes = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/menu",
    component: Menu,
  },
  {
    path: "/users",
    component: Staff,
  },
  {
    path: "/states",
    component: State,
  },
  {
    path: "/city",
    component: City,
  },
  {
    path: "/permissions",
    component: Permission,
  },
  {
    path: "/404",
    component: Page404,
  },
  {
    path: "/coming-soon",
    component: ComingSoon,
  },
  {
    path: "/edit-profile",
    component: EditProfile,
  },
  {
    path: "/notification",
    component: Notification,
  },
  {
    path: "/roles",
    component: Role,
  },
  {
    path: "/offlinequery",
    component: Offline,
  },
  {
    path: "/chat-history",
    component: ChatHistory,
  },
  {
    path: "/chats",
    component: EmployeeChats,
  },
];

export default routes;
